export default "__VITE_ASSET__b49090e4__"